import axios from 'axios'

import {
  AuthToken,
  DomainType,
  GrantType,
  RQauthToken,
  RQrefreshToken,
  TokenType
} from '@vezham/ui/dist/contracts/iam'

const token = '/iam/v1/token'
const refresh = '/iam/v1/refresh'

export const iam = {
  token: async (rq: RQauthToken): Promise<AuthToken> => {
    return axios.post(
      token,
      {
        grant_type: GrantType.AUTH_CODE,
        code: rq.code
      },
      {
        tokenType: TokenType.NO_TOKEN,
        domainType: DomainType.DC
      }
    )
  },
  refresh: async (rq: RQrefreshToken): Promise<AuthToken> => {
    return axios.post(
      refresh,
      {
        grant_type: GrantType.REFRESH_TOKEN,
        refresh_token: rq.refresh_token
      },
      {
        tokenType: TokenType.NO_TOKEN,
        domainType: DomainType.DC
      }
    )
  }
}
